/**
 * Created by Carsten Hibbeler on 22.02.2016.
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { equalArray } from './shallowEqual';

export const amdRequire = window['req' + 'uire'];
export const amdDefine = window['def' + 'ine'];

const cache = {}; //cache for sync load

export const loadModuleByClassName = (className, callback) => {
  if (cache[className]) {
    callback();
  } else {
    console.debug('require async module by className', className);
    amdRequire([ className ], () => {
      console.debug('successfully loaded module by className', className);
      cache[className] = true;
      callback();
    });
  }
};

class AmdRequireComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.prevDependencies = null;
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadDependency();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!equalArray(prevProps.dependencies, this.props.dependencies)) {
      this.loadDependency();
    }
  }

  loadDependency() {
    const dependencies = this.props.dependencies;
    const loadedDependencies = dependencies.map(d => cache[d] && amdRequire(d)).filter(d => !!d);

    if (loadedDependencies.length === dependencies.length) {
      this.prevDependencies = dependencies;
      this.setState({ loadedDependencies });
    } else {
      amdRequire([ ...dependencies ], (...loadedDependencies) => {
        for (let i = 0 ; i < dependencies.length ; i++) {
          cache[dependencies[i]] = true;
        }
        if (this._isMounted) {
          this.prevDependencies = dependencies;
          this.setState({ loadedDependencies });
        }
        this.onDependenciesLoaded(loadedDependencies);
      });
    }
  }

  onDependenciesLoaded(loadedDependencies) {
    if (this.props.onDependenciesLoaded) {
      this.props.onDependenciesLoaded(loadedDependencies);
    }
  }

  render() {
    const { loadedDependencies } = this.state;

    if (loadedDependencies && equalArray(this.prevDependencies, this.props.dependencies)) {
      return this.props.children(...loadedDependencies);
    } else {
      return <div>Loading ({this.props.dependencies.toString()})...</div>;
    }

  }
}

AmdRequireComponent.propTypes = {
  dependencies: PropTypes.array,
  children: PropTypes.func,
  onDependenciesLoaded: PropTypes.func
};

export default AmdRequireComponent;




// WEBPACK FOOTER //
// ./js/utils/amd-utils.js